export enum StudyDesignDirection {
    Prospective = 'prospective',
    Retrospective = 'retrospective',
    CombinedProspectiveAndRetrospective = 'combined prospective and retrospective',
  }
  